import React from 'react';
import { GridItem, IDropdownItem, Search } from '../../../../../ui';
import { PoiAreaSelect } from './PoiAreaSelect';
import { SearchBarWrap } from '../../../../shared/components';
import { withTranslate } from '../../../../shared/i18n/translate';
import styled from '@emotion/styled';

interface IPoiSearchBarProps {
	disabled?: boolean;
	areas: string[];
	onUpdateQuery: (query: string) => void;
	onChangeArea: (item: IDropdownItem | null) => void;
}
export const PoiSearchBar = withTranslate<IPoiSearchBarProps>(
	({ t, areas, disabled, onUpdateQuery, onChangeArea }) => (
		<SearchBarWrap>
			<StyledGridItem columns={[3, { tablet: 12 }]}>
				<label id="poi-area-select-label" htmlFor="poi-area-select">
					{t('poi_area_select_label')}
				</label>
				<PoiAreaSelect
					id="poi-area-select"
					ariaLabelledBy="poi-area-select-label"
					disabled={disabled}
					areas={disabled ? [] : areas}
					onChange={onChangeArea}
				/>
			</StyledGridItem>
			<StyledGridItem columns={[9, { tablet: 12 }]}>
				<label htmlFor="poi-search-bar">{t('search_bar_label')}</label>
				<Search
					disabled={disabled}
					onUpdateQuery={onUpdateQuery}
					placeholder={t('shop_dine_search_placeholder')}
					id="poi-search-bar"
				/>
			</StyledGridItem>
		</SearchBarWrap>
	),
);

const StyledGridItem = styled(GridItem)`
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-top: 15px;
`;
